import { AdvancedTourStep } from '../shared-types';
import { ComponentTourProps } from './component-tour-props';

export function getTaskDestinationTourSteps({
	defaultStyles,
}: ComponentTourProps): AdvancedTourStep[] {
	return [
		{
			id: 'success-destination',
			selector: '[data-tour="success-destination"]',
			content:
				'Set the target destination for when the task succeeds. This will automatically progress to the next step if the task succeeds.',
		},
		{
			id: 'failure-destination',
			selector: '[data-tour="failure-destination"]',
			content:
				'Set the target destination for when the task runs to failure. This will automatically progress to the next step if the task fails.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
